import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="container-xxl py-4 text-start">
      <div className="info-banner shadow-sm mb-5">
        <h1 className="fw-bold mb-3">Privacy Policy</h1>
        <p className="lead text-muted mb-0">At ToyTrade, we value your privacy and are committed to protecting your personal information.</p>
      </div>

      <div className="row justify-content-center">
        <div className="col-lg-9">
          <div className="info-section bg-white p-4 p-md-5 rounded-4 border shadow-sm">
            <p>
              This Privacy Policy outlines how we collect, use, and safeguard your data when you visit our website
              <a className="ms-1 fw-bold text-decoration-none" href='https://toytrade.pk'>https://toytrade.pk</a>.
              By using our site, you agree to the terms outlined in this policy.
            </p>

            <h3>1. Information We Collect</h3>
            <p>We collect information to improve our application and services. The types of information we may collect include:</p>
            <ul className="list-group list-group-flush mb-4">
              <li className="list-group-item bg-transparent px-0 border-0">
                <strong>Personal Information:</strong> When you subscribe to our services and use our platform, we may collect personal details such as your name, email address, and any other information you provide.
              </li>
              <li className="list-group-item bg-transparent px-0 border-0">
                <strong>Non-Personal Information:</strong> We may also collect non-personal data such as your IP address, browser type, operating system, and the pages you visit on our site.
              </li>
            </ul>

            <h3>2. How We Use Your Information</h3>
            <p>The information we collect is used for the following purposes:</p>
            <ul className="list-group list-group-flush mb-4">
              <li className="list-group-item bg-transparent px-0 border-0">
                <strong>To Improve Our Services:</strong> We analyze user behavior to improve the content and functionality of our application.
              </li>
              <li className="list-group-item bg-transparent px-0 border-0">
                <strong>To Communicate with You:</strong> We may use your email address to respond to your inquiries or provide updates.
              </li>
              <li className="list-group-item bg-transparent px-0 border-0">
                <strong>Personalization:</strong> We may use your data to offer content that is relevant to your interests.
              </li>
            </ul>

            <div className="p-3 bg-light rounded-3 mb-4">
              <p className="mb-0 small">
                We may use third-party services, such as Google Analytics, to analyze website traffic. These third parties collect data according to their own privacy policies.
              </p>
            </div>

            <h3>3. Data Security</h3>
            <p>
              We take reasonable measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction.
              However, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security.
            </p>

            <h3>4. Your Rights</h3>
            <p>You have the right to:</p>
            <ul className="list-group list-group-flush mb-4">
              <li className="list-group-item bg-transparent px-0 border-0"><strong>Access:</strong> Request a copy of the personal information we hold about you.</li>
              <li className="list-group-item bg-transparent px-0 border-0"><strong>Correction:</strong> Request corrections to any inaccuracies.</li>
              <li className="list-group-item bg-transparent px-0 border-0"><strong>Deletion:</strong> Request the deletion of your personal information from our records.</li>
            </ul>

            <div className="alert alert-info border-0 rounded-4">
              To exercise these rights, please contact us at
              <a className="ms-1 fw-bold text-decoration-none" href='mailto:admin@topnear.com'>admin@topnear.com</a>
            </div>

            <h3 className="mt-5">Contact Us</h3>
            <p className="text-muted">
              If you have any questions about this policy, please reach out:<br />
              <strong>ToyTrade Pakistan</strong><br />
              Email: <a href='mailto:admin@topnear.com' className="text-decoration-none">admin@topnear.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;